import { render, staticRenderFns } from "./cart-superuser-set-shipping.vue?vue&type=template&id=12fb3144&"
import script from "./cart-superuser-set-shipping.vue?vue&type=script&lang=js&"
export * from "./cart-superuser-set-shipping.vue?vue&type=script&lang=js&"
import style0 from "./cart-superuser-set-shipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports